import {HTTP_CLIENT_KEY, IHTTPClient} from 'common/api/HTTPClient'
import {Container, IInit} from 'common/container/Container'
import {Observable, of} from 'rxjs'
import {FomrContainerConfig} from '../container'
import {IStatusService} from '../../../common/status/StatusService'
import {STATUS_SERVICE_KEY} from '../../../container/app'
import {emptyList, ItemList} from '../../../common/models/ItemList'
import {NewProduct, NewProductDTO, toModel} from '../models/Form'
import {Query} from '../../../common/api/Query'
import {catchError, map} from 'rxjs/operators'
import {prepareURL} from '../../../common/api/http-helpers'
import {ProductDTO} from "../../product/models/ProductDTO";

export interface IFormApi extends IInit {
    getByID(id: string): Observable<NewProduct | undefined>
    byTypeForm(typeForm: string): Observable<NewProduct | undefined>
    add(e: NewProductDTO): Observable<NewProduct | undefined>
    list(): Observable<NewProduct[]>
    update(id: string, e: NewProductDTO): Observable<NewProduct | undefined>
}

export class FormApi implements IFormApi {
    private _container!: Container
    private _httpClient!: IHTTPClient
    private _url!: string
    private _statusService!: IStatusService

    init(c: Container) {
        this._container = c
        this._httpClient = this._container.get<IHTTPClient>(HTTP_CLIENT_KEY)
        this._statusService = this._container.get<IStatusService>(STATUS_SERVICE_KEY)
        this._url = (this._container.config as FomrContainerConfig).moduleFullUrl
    }

    getByID(id: string): Observable<NewProduct | undefined> {
        return this._httpClient.get<NewProduct>({url: `${this._url}/schema/${id}`}).pipe(
            map<NewProductDTO, NewProduct>((d) => toModel(d)),
            catchError((err) => {
                this._statusService.sendStatus({variant: 'error', error: err})
                return of(undefined)
            })
        )
    }

    byTypeForm(typeForm: string): Observable<NewProduct | undefined> {
        return this._httpClient.get<NewProduct>({url: `${this._url}/${typeForm}`}).pipe(
            map<NewProductDTO, NewProduct>((d) => toModel(d)),
            catchError((err) => {
                this._statusService.sendStatus({variant: 'error', error: err})
                return of(undefined)
            })
        )
    }

    add(e: NewProductDTO): Observable<NewProduct | undefined> {
        return this._httpClient.post<NewProduct>({url: this._url, body: e}).pipe(
            catchError((err) => {
                this._statusService.sendStatus({variant: 'error', error: err})
                return of(undefined)
            })
        )
    }

    list(): Observable<NewProduct[]> {
        return this._httpClient.get<NewProductDTO[]>({url: this._url}).pipe(
            map<NewProductDTO[], NewProduct[]>((items) => (items ?? []).map(toModel)),
            catchError((err) => {
                this._statusService.sendStatus({variant: 'error', error: err})
                return of([])
            })
        )
    }

    update(id: string, e: NewProductDTO): Observable<NewProduct | undefined> {
        return this._httpClient.put<NewProduct>({url: `${this._url}/schema/${id}`, body: e}).pipe(
            catchError((err) => {
                this._statusService.sendStatus({variant: 'error', error: err})
                return of(undefined)
            })
        )
    }

}
